import { c } from './contract';
import { v1Router } from './routers/v1';
import { v2Router } from './routers/v2';
import { v3Router } from './routers/v3';
import { webhooksRouter } from './routers/webhooks';

export * from './types';
export * from './constants';
export * from './utils';
export type { MobileAttribution } from './routers/v1/paywall.router';
export type { PromotionalOffer } from './routers/v1/promotionalOffer.router';
export type { BookCoverProgressIndicator } from './routers/v1/bookCoverProgressIndicators.router';
export { adaptedBookCoinsMilestoneSchema } from './routers/v1/candyjar.router';
export type { AdaptedBookCoinsMilestone } from './routers/v1/candyjar.router';

export const galateaRootRouter = c.router(
  {
    v1: v1Router,
    v2: v2Router,
    v3: v3Router,
    webhooks: webhooksRouter,
  },
  { pathPrefix: '/api/galatea', strictStatusCodes: true },
);
